export default __webpack_public_path__ + "static/media/Snd_TryK.104d9012.mp3";